import { render, staticRenderFns } from "./AjusteInventarioTableComponent.vue?vue&type=template&id=213b99d7&"
import script from "./AjusteInventarioTableComponent.vue?vue&type=script&lang=js&"
export * from "./AjusteInventarioTableComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports